


import { Component, Prop, Vue } from 'nuxt-property-decorator'

@Component
export default class ComponentProductScriptsInner extends Vue {
  @Prop({ type: [Object], default: () => {} }) readonly base!: any

  private head() {
    return this.base
  }
}
